import { Link } from "react-router-dom";
import type { WorkItem } from "@/types";

export default function WorkCard({ item }: { item: WorkItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden" style={{ height: 180 }}>
        <img
          src={item.cover}
          alt={`${item.title} 作品封面`}
          title={`${item.title} - 风间由美作品`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-3 top-3 rounded-full bg-secondary-900/85 px-2.5 py-1 text-[11px] font-medium text-background-50">
          {item.year}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-center gap-2">
          <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-medium text-accent-900">
            {item.type}
          </span>
          {item.tags.slice(0, 1).map((t) => (
            <span key={t} className="text-[11px] text-foreground-500">
              #{t}
            </span>
          ))}
        </div>
        <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <span className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-600">
          查看作品详情
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  );
}